import type { SVGAttributes } from "react"

export default function AppLogoIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <rect x="4" y="4" width="56" height="56" rx="18" fill="#5B7FFF" />
      <path
        d="M18 42V28.5C18 27.6716 18.6716 27 19.5 27H24.5C25.3284 27 26 27.6716 26 28.5V42"
        fill="white"
        fillOpacity="0.88"
      />
      <path
        d="M29 42V22.5C29 21.6716 29.6716 21 30.5 21H35.5C36.3284 21 37 21.6716 37 22.5V42"
        fill="white"
        fillOpacity="0.96"
      />
      <path
        d="M40 42V32.5C40 31.6716 40.6716 31 41.5 31H46.5C47.3284 31 48 31.6716 48 32.5V42"
        fill="#DDF4EA"
      />
      <path
        d="M18 47H48"
        stroke="white"
        strokeOpacity="0.45"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M17 23.5L27.5 17L35.5 22L47 15"
        stroke="#DDF4EA"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.5 14.5H47.5V19.5"
        stroke="#DDF4EA"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
